export default "__VITE_ASSET__e4fed17e__"